export const SERVICE_URL = '121.41.5.224:8089'
// export const SERVICE_URL = 'lyj2020.natapp1.cc'

export default {
    /**
     * @description api请求基础路径
     */
    baseUrl: {
      api: '/api/',
      socket: "ws://121.41.5.224:8083/mqtt"
      // socket: "ws://"+SERVICE_URL+"/websocket/2"
    },
  }